import { createReducer, on } from '@ngrx/store';

import { RestPropertyModel } from '@shared/interfaces/rest-portfolio-model.interface';
import { TenantData } from '@shared/interfaces/tenant-data';
import { UserData } from '@shared/interfaces/user-data';
import { RestUserModel } from '@shared/interfaces/user.interface';

import {
  collectAndUpdateTenantSettings,
  loadAllUserPropertiesSucceeded,
  loadUserById,
  loadUserByIdFailed,
  loadUserByIdSucceded,
  loadUserDataSucceded,
  loadUserTenantSucceeded,
  setAuthenticated,
  setUserGeneralRole,
  updateTenantSettings,
  updateTenantSettingsSucceeded,
} from '../actions/user.actions';

export const userFeatureKey = 'user';
export interface IUserStateTree {
  readonly [userFeatureKey]: UserState;
}

export interface UserState {
  tenantData?: TenantData;
  userData?: UserData;
  isAuthenticated?: boolean;
  selectedUser?: RestUserModel;
  selectedUserLoading?: boolean;
  properties?: RestPropertyModel[];
}

export const initialState = {
  isAuthenticated: false,
  userData: {},
  tenantData: {},
};

export const reducer = createReducer(
  initialState,
  on(loadAllUserPropertiesSucceeded, (state, { properties }) => ({
    ...state,
    properties,
  })),

  on(loadUserDataSucceded, (state, action) => ({
    ...state,
    userData: action,
  })),

  on(loadUserTenantSucceeded, (state, action) => ({
    ...state,
    tenantData: action,
  })),

  on(setUserGeneralRole, (state, action) => ({
    ...state,
    userData: {
      ...state.userData,
      generalRole: action.roleName,
    },
  })),

  on(setAuthenticated, (state, action) => ({
    ...state,
    isAuthenticated: action.isAuthenticated,
  })),

  on(loadUserById, state => ({
    ...state,
    selectedUserLoading: true,
  })),
  on(loadUserByIdSucceded, (state, action) => ({
    ...state,
    selectedUser: action,
    selectedUserLoading: false,
  })),
  on(loadUserByIdFailed, (state, action) => ({
    ...state,
    selectedUserLoading: false,
  })),

  on(updateTenantSettings, (state, { settings }) => ({
    ...state,
    tenantData: {
      ...state.tenantData,
      ...settings,
    },
  })),
  on(updateTenantSettingsSucceeded, (state, { settings }) => ({
    ...state,
    tenantData: {
      ...state.tenantData,
      ...settings,
    },
  })),
  on(collectAndUpdateTenantSettings, (state, { settings }) => ({
    ...state,
    tenantData: {
      ...state.tenantData,
      ...settings,
    },
  }))
);
